const LOCALE_PREFIX_PATTERN = /^\/(bg|en|mk)(?=\/|$|\?|#)/

function getDomainDefaultLocale (hostname: string) {
  return hostname.endsWith('.mk') ? 'mk' : 'bg'
}

function getRouteLocale (path: string) {
  return path.match(LOCALE_PREFIX_PATTERN)?.[1]
}

function getSupportedLocale (hostname: string, path: string) {
  const domainDefaultLocale = getDomainDefaultLocale(hostname)
  const routeLocale = getRouteLocale(path)

  if (routeLocale === 'en' || routeLocale === domainDefaultLocale) {
    return routeLocale
  }

  return domainDefaultLocale
}

export default function ({ app, req }: any) {
  let hostname = ''
  if (process.server) {
    hostname = req.headers.host || ''
  } else if (process.client) {
    hostname = window.location.hostname
  }

  const locale = getSupportedLocale(hostname, app.router?.currentRoute?.path || '')
  app.i18n.locale = locale
  app.i18n.fallbackLocale = locale
}
